import React, { useRef, useState, useEffect } from "react";
import "../../Stylesheets/ContactUs/ContactUs.scss";
import whatsapp from "../../assests/Images/Contactus/whatsapp.png";
import telephone from "../../assests/Images/Contactus/telephone.png";
import validator from "validator";
import Swal from "sweetalert2";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const notifySuccess = (message) =>
  toast(<p style={{ fontSize: 16 }}>{message}</p>, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    type: "success"
  });
const ContactUs = () => {
  const [errors, setErrors] = useState({
    name: false,
    phone: false,
    email: false,
    location: false,
    size: false,
  });

  const [toSend, setToSend] = useState({
    name: "",
    phone: "",
    email: "",
    location: "",
    size: "",
  });
  
  const [submittedForm, setSubmittedForm] = useState(false)

  const form = useRef();

  // custom dropdown using ul and li
  const [selectedOption, setSelectedOption] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const [submitted, setSubmitted] = useState(false);

  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (value) => {
    setSelectedOption(value);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const sendEmail = async (e) => {
    e.preventDefault();

    const nameValid = toSend.name.trim() !== "";
    const phoneValid = validator.isMobilePhone(toSend.phone);
    const emailValid = validator.isEmail(toSend.email);
    const locationValid = toSend.location.trim() !== "";
    const sizeValid = selectedOption.trim() !== "";

    setErrors({
      name: !nameValid,
      phone: !phoneValid,
      email: !emailValid,
      location: !locationValid,
      size: !sizeValid,
    });
    console.log({
      name: nameValid,
      phone: phoneValid,
      email: emailValid,
      location:locationValid,
      size: sizeValid,
    })
    if (nameValid && phoneValid && emailValid && locationValid && sizeValid) {
      // Your logic to send the email can go here
      // e.g., Call an API or trigger an email sending function
      console.log('yrss')
      
      // After successful submission, you might want to reset the form fields
      setToSend({
        name: "",
        phone: "",
        email: "",
        location: "",
        size: "",
      });
      setErrors({
        name: false,
        phone: false,
        email: false,
        location: false,
        size: false,
      });
      setSubmitted(true);
      notifySuccess("Form submitted successfully");
    } else {
      setSubmitted(false);
    }
  };

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: false });
  };

  function preventEKeyPress(event) {
    const key = event.key.toLowerCase();
    if (key === "e" || key === "." || key === "-" || key === "+") {
      event.preventDefault();
    }
  }
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  return (
    <>
    <div className="contactus-main-wrapper" id="contact_us_goto">
      <div className="contactus-inner-wrapper">
        <div className="contactus container-fluid">
          <div className="row contact_cover_whole">
            <div className="col-md-6 contact-box-one">
              <div className="contact-box-one-inner">
                <div className="card-heading">
                  <button>
                    <span className="center_text">Contact Us</span>
                  </button>

                  {/* <div ><p className="center_text">Contact Us</p></div> */}
                  <p className="conatctus-desc">
                  Experience the Extraordinary with our virtual tour services.
                  </p>
                </div>

                <div className="phone-whatsapp-wrap">
                  <div class="col">
                    <div class="card">
                      <div className="card-body">
                        <div className="card-img">
                          <img
                            src={telephone}
                            alt="high quality"
                            className="whychooseimg"
                          ></img>
                        </div>
                        <div className="card-content">
                          <div className="card-content-head">Phone Number</div>
                          <div className="card-content-desc">
                            {/* <a href="tel:1800-212-6988" target="_blank">1800-212-6988</a> */}
                            <div onClick={(e)=>{e.preventDefault();window.location.href="tel:1800-212-6988"}} style={{ textDecoration: "none", cursor:"pointer" }}>1800-212-6988</div>

                            </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col">
                    <div class="card">
                      <div className="card-body">
                        <div className="card-img">
                          <img
                            src={whatsapp}
                            alt="high quality"
                            className="whychooseimg"
                          ></img>
                        </div>
                        <div className="card-content">
                          <div className="card-content-head">WhatsApp </div>
                          <div className="card-content-desc">
                            {/* <a href="https://wa.me/9600062660" target="_blank">+91 96000 62660</a> */}
                            <div   onClick={(e) => {
              window.open(" https://wa.me/+919600062660");
            }} style={{ textDecoration: "none", cursor:"pointer" }}>+91 96000 62660</div>

                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 contact-box-two">
              <div className="contactus-form-main-wrapper">
                <form id="contact-form" ref={form} onSubmit={sendEmail} className="form_whole_contain">
                  <div className="letmeknow">
                    {/* <label>
                      Name <span style={{ color: "red" }}>*</span>
                    </label> */}
                    <input
                      className="InputBox"
                      type="text"
                      name="name"
                      placeholder="Enter Your Name"
                      value={toSend.name}
                      required
                      onChange={handleChange}
                    ></input>
                    {errors.name && (
                      <div style={{ textAlign: "left", color: "red",fontFamily:"AvenirBook" }}>
                        Please enter a valid name.
                      </div>
                    )}
                  </div>

                  <div className="letmeknow">
                    {/* <label>
                      Phone Number <span style={{ color: "red" }}>*</span>
                    </label> */}
                    <input
                      className="InputBox"
                      type="number"
                      name="phone"
                      value={toSend.phone}
                      required
                      onKeyPress={preventEKeyPress}
                      maxLength={10}
                      onChange={handleChange}
                      placeholder="Eg. +91-0000000000"
                    ></input>
                    {errors.phone && (
                      <div style={{ textAlign: "left", color: "red",fontFamily:"AvenirBook" }}>
                        Please enter a valid phone number.
                      </div>
                    )}
                  </div>

                  <div className="letmeknow">
                    {/* <label>
                      Email <span style={{ color: "red" }}>*</span>
                    </label> */}
                    <input
                      className="InputBox1"
                      name="email"
                      placeholder="Enter You Email"
                      value={toSend.email}
                      required
                      onChange={handleChange}
                    ></input>
                    {errors.email && (
                      <div style={{ textAlign: "left", color: "red" ,fontFamily:"AvenirBook"}}>
                        Please enter a valid Email.
                      </div>
                    )}
                  </div>

                  <div className="letmeknow">
                    {/* <label>
                      Location <span style={{ color: "red" }}>*</span>
                    </label> */}
                    <input
                      className="InputBox"
                      type="text"
                      name="location"
                      placeholder="Enter Your Location"
                      value={toSend.location}
                      required
                      onChange={handleChange}
                    ></input>
                    {errors.location && (
                      <div style={{ textAlign: "left", color: "red" ,fontFamily:"AvenirBook"}}>
                        Please enter a valid Location.
                      </div>
                    )}
                  </div>

                  <div className="letmeknow">
                    {/* <label>
                      Size <span style={{ color: "red" }}>*</span>
                    </label> */}
                    <div className="custom-dropdown" ref={dropdownRef}>
                      <div className="dropdown-header" onClick={toggleDropdown}>
                        {selectedOption ? selectedOption : "Select a size"}
                        <KeyboardArrowDownIcon
                          className={
                            isOpen ? "arrow-icon rotate" : "arrow-icon"
                          }
                        />
                      </div>
                      {isOpen && (
                        <ul className="dropdown-list">
                          <li onClick={() => handleOptionClick("500 sq ft")}>
                            500 sq ft
                          </li>
                          <li onClick={() => handleOptionClick("1000 sq ft")}>
                          1000 sq ft
                          </li>
                        </ul>
                      )}
                    </div>
                    {submitted && !selectedOption && (
                      <div style={{ textAlign: "left", color: "red" }}>
                        Please select a size.
                      </div>
                    )}
                  </div>
                </form>
                <div className="submit-btn-wrap">
                  <button className="submit-btn" onClick={sendEmail}>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ContactUs;
